export default "__VITE_ASSET__BAmcybV3__"